import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import AllForms from '../../components/AutoReports/AllForms';
import { URL_AUTO_REPORTS } from '../../router/constants';
import useAnalytics from '../../hooks/useAnalytics';

// No permission gate: matches the original (wouter) router, where /auto-reports/add rendered for
// any logged-in user (no `access` prop). Visibility is controlled by the backend-driven main menu.
export const Route = createFileRoute('/_authenticated/auto-reports/add')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.autoReports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddAutoReportRoute,
});

function AddAutoReportRoute() {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  const handleClose = useCallback(() => {
    navigate({ to: URL_AUTO_REPORTS });
    trackEvent(['auto reports', 'click', 'Autoreports close']);
  }, [navigate, trackEvent]);

  return <AllForms closeCallback={handleClose} editingItemId={null} />;
}
